import { OrgWorker } from "model/OrganizationalStructure";
import { MonthSalariesActions } from "model/Salary";

export type MonthSalaryActions =
  | {
      type: MonthSalariesActions.GetAllSalaries;
      payload: { workersWithSalary: OrgWorker[]; total: number };
    }
  | {
      type: MonthSalariesActions.UpdateWorkerSalary;
      payload: { workerWithSalary: OrgWorker };
    } |
    {
      type: MonthSalariesActions.ClearSalaries;
      payload: null;
    } 
  | { type: "SET_IS_LOADING"; payload: boolean }
  | { type: "SET_REQUEST_ERROR"; payload: MonthSalaryState["error"] };

export type MonthSalaryState = {
  workersWithSalary: OrgWorker[];
  isLoading: boolean;
  total: number;
  error: { message: string; err: Error } | null;
};

export const monthSalaryInitState: MonthSalaryState = {
  workersWithSalary: [],
  isLoading: false,
  total: 0,
  error: null,
};

export const monthSalaryStateReducer = (
  state: MonthSalaryState,
  action: MonthSalaryActions
): MonthSalaryState => {
  switch (action.type) {
    case MonthSalariesActions.GetAllSalaries: {
      const existingWorkers = state.workersWithSalary || [];
      const newWorkers = action.payload.workersWithSalary || [];

      const mergedWorkers = [
        ...existingWorkers,
        ...newWorkers.filter(
          (newWorker) =>
            !existingWorkers.some((w) => w.workerId === newWorker.workerId)
        ),
      ];

      return {
        ...state,
        workersWithSalary: mergedWorkers,
        total: action.payload.total,
      };
    }
    case MonthSalariesActions.ClearSalaries: {
      return {
        ...state,
        workersWithSalary: [],
        total: 0,
      };
    }
    case MonthSalariesActions.UpdateWorkerSalary: {
      const { workerWithSalary } = action.payload;

      const workerExists = state.workersWithSalary.some(
        (worker) => worker.workerId === workerWithSalary.workerId
      );

      let updatedSalaries: OrgWorker[];

      if (workerExists) {
        updatedSalaries = state.workersWithSalary.map((worker: OrgWorker) => {
          if (worker.workerId === workerWithSalary.workerId) {
            return workerWithSalary;
          }
          return worker;
        });
      } else {
        updatedSalaries = [...state.workersWithSalary, workerWithSalary];
      }

      return {
        ...state,
        workersWithSalary: updatedSalaries,
      };
    }
    case "SET_IS_LOADING": {
      return { ...state, isLoading: action.payload };
    }
    case "SET_REQUEST_ERROR": {
      return { ...state, error: action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${(action as any).type}`);
    }
  }
};
